import { z } from "zod";

export const positionSchema = z.object({
  id: z.number(),
  position: z.string(),
  label: z.string(),
  shelvingUnit: z.object({
    id: z.number(),
    identifier: z.string(),
    path: z.object({
      id: z.number(),
      identifier: z.string(),
      warehouse: z.object({
        id: z.number(),
        name: z.string(),
        status: z.boolean(),
      }),
    }),
  }),
  tiresets: z.object({
    type: z.string(),
    id: z.string(),
    in_hotel: z.boolean().default(false),
    car: z.object({
      id: z.string(),
      licence: z.string(),
      label: z.string(),
      relation: z.object({
        id: z.string(),
        name: z.string(),
      }),
      freestock_tire: z.boolean().default(false),
    }),
  }),
});

export const positionFormSchema = z.object({
  id: z.number(),
  label: z.string(),
  position: z
    .string()
    .regex(/^\d+(\.\d+)?$/, "crud.positions.validate.position"),
  shelving_unit_id: z.string(),
  shelvingUnit_id: z.string(),
  shelvingUnit: z.object({
    path: z.object({
      warehouse_id: z.string(),
    }),
  }),
  sticker: z.object({
    svgUrl: z.string(),
    pdfUrl: z.string(),
  }),
});
